module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  var addressList = value; 
    ; __append("\n")
    ;  if (addressList && addressList.length) { 
    ; __append("\n<ul>\n")
    ; 
Util.each(addressList, function (value) {
	var address = Util.clone(value);

	if (!Util.isDefined(address.type)) {
		address.type = Glonass.AddressType.Settlement;
	}

	var items = [];

	card.encode(address, {
		"house": "д.",
		"building": "корп.",
		"flat": "кв.",
		"entrance": "подъезд ",
		"floor": "этаж ",
		"intercom": "домофон ",
		"road": "трасса "
	}, mode);

    ; __append("\n\n")
    ;  if (address.type == Glonass.AddressType.Settlement) { 
    ; __append("\n")
    ;  items.push(Util.String.join([address.text, address.house, address.building, address.flat, address.entrance, address.floor, address.intercom])); 
    ; __append("\n")
    ;  } else { 
    ; __append("\n")
    ;  items.push(Util.String.join([address.road, address.mileage])); 
    ; __append("\n")
    ;  } 
    ; __append("\n\n")
    ;  items.push(address.comment); 
    ; __append("\n")
    ;  items = Util.String.join(items, ", "); 
    ; __append("\n<li>\n")
    ; __append(escapeFn( Html.br(items) ))
    ; __append("\n</li>\n")
    ;  }); 
    ; __append("\n</ul>\n")
    ;  } 
  }
  return __output.join("");

}